// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"PageWrapper_page-wrapper__29l_0"};